import { render, staticRenderFns } from "./init-fee-revenue-sharing.vue?vue&type=template&id=6262221b&scoped=true&"
import script from "./init-fee-revenue-sharing.vue?vue&type=script&lang=js&"
export * from "./init-fee-revenue-sharing.vue?vue&type=script&lang=js&"
import style0 from "./init-fee-revenue-sharing.vue?vue&type=style&index=0&id=6262221b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6262221b",
  null
  
)

export default component.exports